import React, { useContext } from "react"

import classNames from "@utils/classnames"
import CommonContext from "@src/context"
import { animateScroll } from "react-scroll"
import Clickable from "@components/clickable"

import styles from "./toTop.module.scss"

const ToTop = () => {
  const { scrollY } = useContext(CommonContext)
  return (
    <Clickable
      className={classNames(styles.toTop, {
        [styles.show]: scrollY > 800,
      })}
      onClick={() => {
        animateScroll.scrollTo(0, {
          duration: 400,
        })
      }}
    />
  )
}

export default ToTop
